import { useContext } from 'react'
import { RoleContext } from '../providers'

export const useRoles = (): string => {
  return useContext(RoleContext) as string
}
